import { render, staticRenderFns } from "./CreateDriverV2.vue?vue&type=template&id=a172c4d2&"
import script from "./CreateDriverV2.vue?vue&type=script&lang=js&"
export * from "./CreateDriverV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports